module.exports = __webpack_public_path__ + "img/live_patch.5ec3ad11.jpg";